// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"jS-z","trustedRetailerTooltipWrapper":"kS-z"};